import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PaginatedList } from '../../../components/PaginatedList/PaginatedList';
import { ImageCroppingPresets } from '../../../modules/Media/MediaUtils';
import { HorizontalStack, SmartContainer } from "../../../styles/Containers";
import { AssetCard } from '../Assets/AssetCard';
import { restoreAsset, searchViewAssets } from '../Assets/redux/assets.actions';
import { FullAssets } from '../Assets/redux/assets.selectors';
import { StyledFullScreenModal } from '../../components/Content/FullScreenModal';
import { AssetViewer } from '../Assets/AssetViewer';
import { ViewAssetViewer } from './ViewAssetViewer';
import { ModelList } from '../../../components/PaginatedList/ModelList';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconFeed, IconGrid, IconRefresh } from '../../Icons';
import { jsRespondTo } from '../../../styles/Theme';
import { ScopedVisitorLoader } from '../../../components/Loaders/ScopedVisitorLoader';
import { FullNetwork } from '../../../redux/Network/network.selectors';
import { StyledAssetWrap } from '../Assets/AssetsList';
import { useWindowSize } from '../../services/CaptureCollabService';

export const ViewAssetsList = ({ view, myRole = null }) => {

    // New Modal
    const dispatch = useDispatch();
    const store = FullAssets();
    const fullNetwork = FullNetwork();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(999);
    const [openViewer, setOpenViewer] = useState(false);
    const [activeAsset, setActiveAsset] = useState(null);
    const [grid, setGrid] = useState(true);
    const auth = useSelector(state => state.auth)
    const windowSize = useWindowSize();

    useEffect(() => {
        const args = {
            viewId: view?.id
        }
        dispatch(searchViewAssets(0, 18, null, null, args, view?.id));
    }, [view])

    const handleSelect = (item) => {
        setOpenViewer(true);
        setActiveAsset(item);
    }

    const runRefresh = () => {
        if (window?.location) window.location.reload();
    }

    const setAssetByIndex = (index) => {

        if (!store?.items?.rows[index]) return;

        setActiveAsset(store?.items?.rows[index])
        // dispatch(replace(`/asset/${store?.items?.rows[index].id}`))
    }

    const formatted = (store?.items) ? store?.items.rows.map(asset => {
        if (!asset?.id) return null;
        return { id: asset.id, title: asset.name, description: '', full: asset }
    }
    ) : []
    const total = (store?.items) ? store?.items?.count : 0;
    const pageCount = Math.ceil(total / limit);

    const renderMediaCard = (item, onClickItem) => (<AssetCard display="feed" item={item} onClick={onClickItem} crop={ImageCroppingPresets.preview} noControls={false} />)
    const renderCustomControls = () => {
        return (
            <HorizontalStack flex align="center" justify="flex-end" width="100%">
                <SmartContainer>
                    <StyledIconButton onClick={() => runRefresh()}>
                        <IconRefresh />
                    </StyledIconButton>
                </SmartContainer>
                <SmartContainer>
                    <StyledIconButton onClick={() => setGrid(!grid)}>
                        {!grid && (<IconGrid />)}
                        {grid && (<IconFeed />)}
                    </StyledIconButton>
                </SmartContainer>
            </HorizontalStack>
        )
    }

    const getGridColumns = () => {
        // Single Column
        if (!grid) return 1;

        // Mobile
        const isMobile = jsRespondTo('mobile');
        if (isMobile) return 3;

        // Tablet
        const isTablet = jsRespondTo('tablet');
        if (isTablet) return 4;

        // Desktop
        const isDesktop = jsRespondTo('desktop');
        if (isDesktop) return 5;

        // Large
        const isLarge = jsRespondTo('large');
        if (isLarge) return 6;

        // XLarge
        const isXLarge = jsRespondTo('xlarge');
        if (isXLarge) return 7;

        // XXLarge
        const isXXLarge = jsRespondTo('2xlarge');
        if (isXXLarge) return 7;

        return 3;

    }


    // Visitor Token
    if (!auth.session) return (<ScopedVisitorLoader networkId={fullNetwork.network.id} />)

    // let cols = (grid) ? 3 : 1;
    // const isMobile = jsRespondTo('mobile');
    // if (isMobile && grid) cols = 2;
    let cols = getGridColumns();

    return (
        <StyledAssetWrap>

            <ModelList
                model="Asset"
                action={searchViewAssets}
                restore={restoreAsset}
                selector={FullAssets}
                onSelect={handleSelect}
                variant="cards"
                defaultLimit={20}
                customRenderer={renderMediaCard}
                hideSearch={true}
                infiniteScroll={true}
                paginationControls={renderCustomControls}
                columns={cols}
                forceLayout={true}
                filters={{ viewId: view?.id }}
            />


            <StyledFullScreenModal open={openViewer} onClose={() => setOpenViewer(false)} fullWidth>
                <ViewAssetViewer onClose={() => setOpenViewer(false)} asset={activeAsset} setAssetByIndex={setAssetByIndex} />
            </StyledFullScreenModal>

        </StyledAssetWrap>
    )
}